import i18n from '@/i18n';
import { ExOption } from '@/proto/field';

/**
 * 在请求token的时候，为了简化处理逻辑，filters里面的字段用来给后台解析
 * filters外面的字段用来回显表单，为了避免和后台字段有冲突（后台有些老代码会同时读filters外面和里面的字段）,
 * 回显的统一加上了standard_前缀
 */
export enum KuiklyFieldKey {
  IsError = 'standard_is_err',
  Method = 'standard_method',
  URL = 'standard_url',
  // 日志正文
  Msg = 'standard_msg',
  Level = 'standard_level',
  ErrorMsg = 'standard_error_msg',
  SessionId = 'standard_session_id',
  API = 'standard_url',
  NetType = 'standard_net_type',
  Platform = 'standard_platform',
  Operator = 'standard_isp',
  Brand = 'standard_brand',
  Model = 'standard_model',
  Browser = 'standard_browser',
  Region = 'standard_region',
  SdkVersion = 'standard_sdk_version',
  KuiklyVersion = 'standard_hippy_version',
  FrameworkVersion='standard_framework_version',
  AppVersion = 'standard_app_version',
  ProductVersion = 'standard_product_version',
  Os = 'standard_os',
  Ext1 = 'standard_ext1',
  Ext2 = 'standard_ext2',
  Ext3 = 'standard_ext3',
  Domain = 'standard_domain',
  Status = 'standard_status',
  Ret = 'standard_ret',
  Type = 'standard_type',
  AccountId = 'standard_account_id',
  From = 'standard_from',
  Strategy = 'standard_page_load_strategy',
  DurationCost = 'standard_duration_cost',
  TransferSize = 'standard_transfer_size',
  HttpVersion = 'standard_http_version',
  Name = 'standard_name',
  Duration = 'standard_duration',
  AbTags = 'standard_ab_tags',
}

export enum KuiklyFieldFilterKey {
  TransferSize = 'transfer_size',
  Method = 'method',
  HttpVersion = 'http_version',
  IsError = 'is_err',
  URL = 'url',
  Msg = 'msg',
  Level = 'level',
  ErrorMsg = 'error_msg',
  SessionId = 'session_id',
  API = 'url',
  NetType = 'net_type',
  Platform = 'platform',
  Operator = 'isp',
  Brand = 'brand',
  Model = 'model',
  Browser = 'browser',
  Region = 'region',
  SdkVersion = 'sdk_version',
  KuiklyVersion = 'kuikly_version',
  AppVersion = 'app_version',
  ProductVersion = 'product_version',
  QiMei='qimei',
  Os = 'os',
  Ext1 = 'ext1',
  Ext2 = 'ext2',
  Ext3 = 'ext3',
  Domain = 'domain',
  Status = 'status',
  Ret = 'ret',
  Type = 'type',
  AccountId = 'account_id',
  From = 'from',
  Strategy = 'page_load_strategy',
  DurationCost = 'duration_cost',
  Name = 'name',
  Duration = 'duration',
  ElapsedTime = 'elapsed_time',
  AbTags = 'ab_tags',
  FrameworkVersion = 'framework_version'
}

export enum KuiklyLogType {
  // log 日志集合
  LogCollectionLog = 'log',
  // pv 日志集合
  LogCollectionPV = 'pv',
  // 自定义事件日志集合
  LogCollectionEvent = 'event',
  // 自定义测速日志集合
  LogCollectionCustom = 'custom',
  // 测速性能指标集合
  LogCollectionPerformance = 'performance',
  // 测速 kuikly 性能指标集合
  LogCollectionKuiklyPerformance = 'kuiklyPerformance',
  // 页面性能指标集合
  LogCollectionWebVitals = 'web-vitals',
  // 静态资源测速指标集合
  LogCollectionStatic = 'static',
  // 接口测速指标集合
  LogCollectionFetch = 'fetch',
  // bridge 接口测速指标集合
  LogCollectionBridge = 'bridge',
  // 测速性能指标集合 小程序 setData
  LogCollectionMiniProgramSetData = 'setData',
  // 测速性能指标集合 小程序 loadPackage
  LogCollectionMiniProgramLoadPackage = 'loadPackage',
}

export enum KuiklyLogLevelNum {
  ERROR = 200002,
  SDK_ERROR = 2048,
  PROMISE_ERROR = 8,
  AJAX_ERROR = 16,
  SCRIPT_ERROR = 200004,
  WEBSOCKET_ERROR = 32768,
  IMAGE_ERROR = 64,
  CSS_ERROR = 128,
  MEDIA_ERROR = 512,
  RET_ERROR = 1024,
  NATIVE_ENGINE_ERROR = 200001,
}

export const FIELD_DEFAULT_OPERATOR = {

};

export const KUIKLY_LOG_ERROR = [
  KuiklyLogLevelNum.ERROR,
  KuiklyLogLevelNum.SDK_ERROR,
  KuiklyLogLevelNum.PROMISE_ERROR,
  KuiklyLogLevelNum.AJAX_ERROR,
  KuiklyLogLevelNum.SCRIPT_ERROR,
  KuiklyLogLevelNum.WEBSOCKET_ERROR,
  KuiklyLogLevelNum.IMAGE_ERROR,
  KuiklyLogLevelNum.CSS_ERROR,
  KuiklyLogLevelNum.MEDIA_ERROR,
  KuiklyLogLevelNum.RET_ERROR,
  KuiklyLogLevelNum.NATIVE_ENGINE_ERROR,
];

export enum KuiklyPerfStrategy {
  CacheFetchLatest = 'CacheFetchLatest',
  NetworkFetchLatest = 'NetworkFetchLatest',
}

export const KUIKLY_PERF_STRATEGY_OPTIONS = [
  {
    value: KuiklyPerfStrategy.CacheFetchLatest,
    label: i18n.t('加载本地最新版本'),
  },
  {
    value: KuiklyPerfStrategy.NetworkFetchLatest,
    label: i18n.t('实时加载远端最新版本'),
  },
];

// 后台filters接收的value只能是string
export enum KuiklyErrorLevel {
  NativeError = '200001',
  CrossError = '200002'
}

export const KUIKLY_ERROR_LEVEL_OPTIONS = [
  {
    value: KuiklyErrorLevel.NativeError,
    label: i18n.t('Native层错误'),
  },
  {
    value: KuiklyErrorLevel.CrossError,
    label: i18n.t('跨端层错误'),
  },
];

export enum KuiklyLogLevel {
  INFO = '2',
  ERROR = '200002',
  SDK_ERROR = '2048',
  PROMISE_ERROR = '8',
  AJAX_ERROR = '16',
  SCRIPT_ERROR = '200004',
  WEBSOCKET_ERROR = '32768',
  IMAGE_ERROR = '64',
  CSS_ERROR = '128',
  MEDIA_ERROR = '512',
  REPORT = '200003',
  RET_ERROR = '1024',
  NATIVE_ENGINE_ERROR = '200001',
}

export const KUIKLY_LOG_LEVEL_OPTIONS = [
  { label: i18n.t('一般日志'), value: KuiklyLogLevel.INFO },
  { label: i18n.t('错误日志'), value: KuiklyLogLevel.ERROR },
  { label: i18n.t('aegis sdk错误日志'), value: KuiklyLogLevel.SDK_ERROR },
  { label: i18n.t('promise错误日志'), value: KuiklyLogLevel.PROMISE_ERROR },
  { label: i18n.t('ajax错误日志'), value: KuiklyLogLevel.AJAX_ERROR },
  { label: i18n.t('script错误日志'), value: KuiklyLogLevel.SCRIPT_ERROR },
  { label: i18n.t('websocket错误日志'), value: KuiklyLogLevel.WEBSOCKET_ERROR },
  { label: i18n.t('图片加载错误日志'), value: KuiklyLogLevel.IMAGE_ERROR },
  { label: i18n.t('css资源加载错误日志'), value: KuiklyLogLevel.CSS_ERROR },
  { label: i18n.t('media加载错误日志'), value: KuiklyLogLevel.MEDIA_ERROR },
  { label: i18n.t('report日志'), value: KuiklyLogLevel.REPORT },
  { label: i18n.t('ret_error日志'), value: KuiklyLogLevel.RET_ERROR },
  { label: i18n.t('native引擎错误日志'), value: KuiklyLogLevel.NATIVE_ENGINE_ERROR },
];

export enum KuiklyLogType {
  // LogTypeLog log 日志集合
  LogTypeLog = 'log',
  // LogTypePV pv 日志集合
  LogTypePV = 'pv',
  // LogTypeEvent 自定义事件日志集合
  LogTypeEvent = 'event',
  // LogTypeCustom 自定义测速日志集合
  LogTypeCustom = 'custom',
  // LogTypeHippyPerformance 测速 hippy 性能指标集合
  LogTypeHippyPerformance = 'performance',
  // LogTypeStatic 静态资源测速指标集合
  LogTypeStatic = 'static',
  // LogTypeFetch 接口测速指标集合
  LogTypeFetch = 'fetch',
  // LogTypeNativeLoadEvent 页面加载事件
  LogTypeNativeLoadEvent = 'native_load_event',
}

export const KUIKLY_LOG_TYPE_OPTIONS = [
  { label: i18n.t('日志'), value: KuiklyLogType.LogTypeLog },
  { label: i18n.t('页面访问'), value: KuiklyLogType.LogTypePV },
  { label: i18n.t('自定义事件'), value: KuiklyLogType.LogTypeEvent },
  { label: i18n.t('自定义测速'), value: KuiklyLogType.LogTypeCustom },
  { label: i18n.t('性能'), value: KuiklyLogType.LogTypeHippyPerformance },
  { label: i18n.t('静态资源'), value: KuiklyLogType.LogTypeStatic },
  { label: i18n.t('API监控'), value: KuiklyLogType.LogTypeFetch },
  { label: i18n.t('页面加载事件'), value: KuiklyLogType.LogTypeNativeLoadEvent },
];

export const getLocalFieldKuikly = (fieldKey: KuiklyFieldFilterKey) => {
  const fields: Partial<Record<KuiklyFieldFilterKey, ExOption[]>> = {
    [KuiklyFieldFilterKey.Strategy]: KUIKLY_PERF_STRATEGY_OPTIONS,
    [KuiklyFieldFilterKey.Level]: KUIKLY_ERROR_LEVEL_OPTIONS,
  };
  return fields[fieldKey];
};
